// extracted by mini-css-extract-plugin
export var closeButton = "_h7-2";
export var closeButtonIcon = "_h7-3";
export var lightboxContent = "_h7-1";
export var lightboxOverlay = "_h7-0";